import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {NgcCookieConsentService} from 'ngx-cookieconsent';
import {LocaleService} from '../services/locale.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(
    private router: Router,
    private cookieService: NgcCookieConsentService,
    public localeService: LocaleService,
  ) { }

  get isUAERoute(): boolean {
    return this.router.url.startsWith('/uae') || this.router.url.startsWith('/ga');
  }

  ngOnInit(): void {
    if (this.isUAERoute) {
      this.cookieService.hasConsented();
      this.cookieService.close(false);
      this.cookieService.destroy();
    }
  }



}
